const mapSortFilterToRtpField = (sort: SelectedSort, isLiveRtp?: boolean) => {
  const field = sort.name;
  if (field?.includes('rtpLive')) {
    return field as RtpField;
  }
  return isLiveRtp ? 'rtpLivePastDay' : undefined;
};

export default mapSortFilterToRtpField;
